import PropTypes from 'prop-types';
import { userSharedProps } from '@common/propTypes';

export const userPropType = PropTypes.shape({
  ...userSharedProps,
  companyId: PropTypes.string,
  roleIds: PropTypes.arrayOf(PropTypes.string).isRequired,
});
